import client from 'data/client';
import { CDError } from 'utils/error';

export type ReferralVariables = {
  name: string;
  restaurantName: string;
  city: string;
  phoneNumber: string;
  email?: string;
};

export type Response = {
  status: string;
};

const referralRequest = async ({
  name,
  restaurantName,
  city,
  phoneNumber,
  email,
}: ReferralVariables) => {
  try {
    const { data } = await client.post(
      `/referral`,
      {
        name,
        restaurantName,
        city,
        phoneNumber,
        email,
      },
      { headers: { 'content-type': 'application/json' } },
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError('', error.response.data);
  }
};

export default referralRequest;
